import React, { useState, useEffect } from "react";
import DashboardNav from "../DashboardNav/DashboardNav";
import DashboardSidebar from "../DashboardSidebar/DashboardSidebar";
import WelcomeSection from "./WelcomeSection/WelcomeSection";
import UpcomingTrips from "./UpcomingTrips/UpcomingTrips";
import ActiveEsim from "./ActiveEsim/ActiveEsim";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

const MainPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 991);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 991 && isSidebarOpen) {
        setIsSidebarOpen(false);
      } else if (window.innerWidth >= 991 && !isSidebarOpen) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isSidebarOpen]);

  return (
    <>
      <DashboardSidebar isOpen={isSidebarOpen} />
      <DashboardNav
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
      />
      <div className="dashboard-layout">
        <div
          className={`main-section ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="main-dashboard-page-content">
            <Breadcrumbs
              items={[{ label: "Dashboard", href: "/user-information" }]}
            />
            <div className="row gap-4">
              <div className="col-12">
                {" "}
                <WelcomeSection />{" "}
              </div>
              <div className="col-12">
                {" "}
                <UpcomingTrips />{" "}
              </div>
              <div className="col-12">
                {" "}
                <ActiveEsim />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainPage;
